// Shared UI assets only. Keep page-specific registries out of client bundles.
import { careerAssets } from "./modules/career";
import { contactPartnersAssets } from "./modules/contact-partners";
import { homeAssets } from "./modules/home";
import { logoAssets } from "./modules/logos";
import { marketingAssets } from "./modules/marketing";
import { partnershipAssets } from "./modules/partnership";
import textureImage from "../images/texture.webp";
import serviceCtaBg from "../images/service-cta-bg.webp";
import industryBg from "../images/industry-details-banner.webp";
import foodBg from "../images/food-banner.webp";
import industryBannerBg from "../images/industry-bg.webp";
const ICON_BASE_URL = process.env.NEXT_PUBLIC_IMAGE_BASE_URL || "";

export const Images = {
  java_graphic: `${ICON_BASE_URL}/assets/images/java_graphics.svg`,
  kotlin: `${ICON_BASE_URL}/assets/images/kotlin.webp`,
  swift: `${ICON_BASE_URL}/assets/images/swift.webp`,
  caseStudyBg: `${ICON_BASE_URL}/assets/icons/showcase-bg.webp`,
  membership: {
    authorize: `${ICON_BASE_URL}/assets/images/awards/authorize.webp`,
    fieo: `${ICON_BASE_URL}/assets/images/awards/fedration-of-export.webp`,
    igda: `${ICON_BASE_URL}/assets/images/awards/igda.webp`,
    iso1: `${ICON_BASE_URL}/assets/images/awards/iso-1.webp`,
    iso2: `${ICON_BASE_URL}/assets/images/awards/iso-2.webp`,
    nasscom: `${ICON_BASE_URL}/assets/images/awards/nasscom.webp`,
    oisv: `${ICON_BASE_URL}/assets/images/awards/oisv.webp`,
    stpi: `${ICON_BASE_URL}/assets/images/awards/software-technology.webp`,
    tie: `${ICON_BASE_URL}/assets/images/awards/tie.webp`,
    usCompliance1: `${ICON_BASE_URL}/assets/icons/us-compliance-1.svg`,
    usCompliance2: `${ICON_BASE_URL}/assets/icons/us-compliance-2.svg`,
    usCompliance3: `${ICON_BASE_URL}/assets/icons/us-compliance-3.svg`,
    usCompliance4: `${ICON_BASE_URL}/assets/icons/us-compliance-4.svg`,
    usCompliance5: `${ICON_BASE_URL}/assets/icons/us-compliance-5.svg`,
    usCompliance6: `${ICON_BASE_URL}/assets/icons/us-compliance-6.svg`,
    usCompliance7: `${ICON_BASE_URL}/assets/icons/us-compliance-7.svg`,
    usCompliance8: `${ICON_BASE_URL}/assets/icons/us-compliance-8.svg`,
    usCompliance9: `${ICON_BASE_URL}/assets/icons/us-compliance-9.svg`,
    usCompliance10: `${ICON_BASE_URL}/assets/icons/us-compliance-10.svg`,
    usCompliance11: `${ICON_BASE_URL}/assets/icons/us-compliance-11.svg`,
    usCompliance12: `${ICON_BASE_URL}/assets/icons/us-compliance-12.svg`,
  },
  foodBg: foodBg,
  industryBg: industryBg,
  imagePlaceholder: `${ICON_BASE_URL}/assets/images/image_placholder.webp`,
  homepage: {
    AI_and_ML: `${ICON_BASE_URL}/assets/images/home-page/AI_and_ML.webp`,
    Blockchain_home: `${ICON_BASE_URL}/assets/images/home-page/Blockchain.webp`,
    Cloud: `${ICON_BASE_URL}/assets/images/home-page/Cloud.webp`,
    Computer_Vision_home: `${ICON_BASE_URL}/assets/images/home-page/Computer_Vision.webp`,
    Data_Science_Analytics: `${ICON_BASE_URL}/assets/images/home-page/Data_Science_Analytics.webp`,
    Natural_Language_Processing_home: `${ICON_BASE_URL}/assets/images/home-page/Natural_Language_Processing.webp`,
    VR: `${ICON_BASE_URL}/assets/images/home-page/VR.webp`,
  },
  about_2: `${ICON_BASE_URL}/assets/images/about/about-2.webp`,
  YoutubeThumbNew: `${ICON_BASE_URL}/assets/images/youtube_thumb_new.webp`,
  user1: `${ICON_BASE_URL}/assets/images/user1.webp`,
  user2: `${ICON_BASE_URL}/assets/images/user2.webp`,
  AdvancedBg: `${ICON_BASE_URL}/assets/images/AdvancedBG.svg`,
  user3: `${ICON_BASE_URL}/assets/images/user3.webp`,
  user4: `${ICON_BASE_URL}/assets/images/user4.webp`,
  ai_card_bg: `${ICON_BASE_URL}/assets/images/ai-card-bg.webp`,
  ai_container_bg: `${ICON_BASE_URL}/assets/images/ai-container-bg.webp`,
  footer: `${ICON_BASE_URL}/assets/images/footer.webp`,
  footerLogo: `${ICON_BASE_URL}/assets/images/footer-logo.svg`,
  footerWatermark: `${ICON_BASE_URL}/assets/images/footerWatermark.webp`,
  logo: `${ICON_BASE_URL}/assets/images/logo.svg`,
  logoIcon: `${ICON_BASE_URL}/assets/images/logo-icon.svg`,
  logoBlue: `${ICON_BASE_URL}/assets/images/logo-blue.svg`,
  texture: textureImage,
  rating: `${ICON_BASE_URL}/assets/images/raiting.webp`,
  tagDivider: `${ICON_BASE_URL}/assets/images/tag-devider.webp`,
  serviceBg: `${ICON_BASE_URL}/assets/images/service-bg.webp`,
  serviceCtaBg: serviceCtaBg,
  comparisonBg: `${ICON_BASE_URL}/assets/icons/comparison-bg.webp`,
  cardicon1: `${ICON_BASE_URL}/assets/images/cardicon1.svg`,
  cardicon2: `${ICON_BASE_URL}/assets/images/cardicon2.svg`,
  cardicon3: `${ICON_BASE_URL}/assets/images/AI Agent Development-HOVER 1.svg`,
  cardicon4: `${ICON_BASE_URL}/assets/images/cardicon4.svg`,
  industryBannerBg: industryBannerBg,
  plus: `${ICON_BASE_URL}/assets/images/plus.svg`,
  get_free_consulation_light: `${ICON_BASE_URL}/assets/images/get-free-consultation-light.webp`,
  get_free_consulation_dark: `${ICON_BASE_URL}/assets/images/get-free-consultation-dark.webp`,
  laravel_need_a_price: `${ICON_BASE_URL}/assets/icons/laravel/need-a-price.png`,
  industry1: `${ICON_BASE_URL}/assets/images/industry-1.webp`,
  industry2: `${ICON_BASE_URL}/assets/images/industry-2.webp`,
  industry3: `${ICON_BASE_URL}/assets/images/industry-3.webp`,
  industry4: `${ICON_BASE_URL}/assets/images/industry-4.webp`,
  typescript: `${ICON_BASE_URL}/assets/images/typescript.webp`,
  dotnet: `${ICON_BASE_URL}/assets/images/dotnet.webp`,
  nodejs: `${ICON_BASE_URL}/assets/images/nodejs.webp`,
  java: `${ICON_BASE_URL}/assets/images/java.webp`,
  ruby: `${ICON_BASE_URL}/assets/images/ruby.webp`,
  mobile: `${ICON_BASE_URL}/assets/images/mobile.webp`,
  behindImage: `${ICON_BASE_URL}/assets/images/behind-image.webp`,
  konstantLogo: `${ICON_BASE_URL}/assets/images/konstant-logo.svg`,
  stars: `${ICON_BASE_URL}/assets/images/stars.svg`,
  foodDeliveryApp: `${ICON_BASE_URL}/assets/images/food-delivery-app.webp`,
  homePage: homeAssets.homePage,
  logoSet: logoAssets.logoSet,
  contactUs: contactPartnersAssets.contactUs,
  testimonial: marketingAssets.testimonial,
  portfolio: marketingAssets.portfolio,
  career: careerAssets.career,
  aiButtonStars: partnershipAssets.aiButtonStars,
  dmcaBadge: `${ICON_BASE_URL}/assets/images/dmca-badge.webp`,
  goldVerified: `${ICON_BASE_URL}/assets/images/gold-verified.svg`,
};
